import { useEffect, useState } from "react";
import { isEqual } from "lodash";
import { FallbackQueryHook } from "./types";

export const useFallbackQuery = <TArgs, TResult>(
    queryHook: FallbackQueryHook<TArgs, TResult>,
    args: TArgs,
    options?: {
        skip?: boolean;
        isEmpty?: (data: TResult | undefined) => boolean;
    }
) => {
    const [fallback, setFallback] = useState(false);
    const [prevArgs, setPrevArgs] = useState<TArgs>(args);

    const isEmpty =
        options?.isEmpty ?? ((data) => !data || (Array.isArray(data) && data.length === 0));

    const queryArgs = fallback ? ({} as TArgs) : args;
    const result = queryHook(queryArgs, { skip: options?.skip });

    useEffect(() => {
        if (!isEqual(prevArgs, args)) {
            setFallback(false);
            setPrevArgs(args);
        }
    }, [args, prevArgs]);

    useEffect(() => {
        if (!fallback && !result.isLoading && !result.isFetching && isEmpty(result.data)) {
            setFallback(true);
        }
    }, [fallback, result.data, result.isLoading, result.isFetching]);

    return result;
};